module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0065.jpg?v=39b5ba89";